import React from "react";
import { FaFolderPlus } from "react-icons/fa6";
import { FiUpload } from "react-icons/fi";
import { Button } from "reactstrap";
import { GetLanguageString } from "../../helper/Components";
import { DOCUMENT_STYLES } from "../hooks/useDocumentUtils";

/**
 * UploadOptionsOverlay Component
 * Shows file and folder upload buttons in an overlay
 */
const UploadOptionsOverlay = ({
  onFileUpload,
  onFolderUpload,
  overlayRef,
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div style={DOCUMENT_STYLES.overlayStyle}>
      <div
        ref={overlayRef}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          style={DOCUMENT_STYLES.buttonStyle}
          onClick={onFileUpload}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-10px)";
            e.target.style.boxShadow = "0 10px 15px rgba(0, 0, 0, 0.2)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
          }}
        >
          <FiUpload size={30} color="#35A29F" />
          <GetLanguageString props={"upload_file"} />
        </Button>

        <Button
          style={DOCUMENT_STYLES.buttonStyle}
          onClick={onFolderUpload}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-10px)";
            e.target.style.boxShadow = "0 10px 15px rgba(0, 0, 0, 0.2)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
          }}
        >
          <FaFolderPlus size={30} color="#FFCA28" />
          <GetLanguageString props={"upload_folder"} />
        </Button>
      </div>
    </div>
  );
};

export default UploadOptionsOverlay;
